import React from "react";
import "./ChatHeader.scss";

interface ChatHeaderProps {
  title: string;
  onMenuClick?: () => void;
  showMenuButton?: boolean;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  onMenuClick,
  showMenuButton = false,
}) => {
  return (
    <div className="chat-header">
      {showMenuButton && (
        <button
          className="chat-header-menu-button"
          onClick={onMenuClick}
          aria-label="Open chat list"
        >
          ☰
        </button>
      )}
      <h1 className="chat-header-title">{title}</h1>
    </div>
  );
};

export default ChatHeader;

